import { render } from "./agent-item.vue?vue&type=template&id=d7e3adf6"
import script from "./agent-item.vue?vue&type=script&lang=js"
export * from "./agent-item.vue?vue&type=script&lang=js"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-team/carousel-fashion/agent-item.vue'],['render',render],['__file',"agent-item.vue"]])

export default __exports__